/**
 * Remembers the last selected workspace in this browser (WP-111 build step 9). Only an id is
 * stored — never tokens or workspace data — and every read is re-checked against the
 * caller's workspace list, so a stale or tampered value just falls back to the first one.
 */
const KEY = "wato.lastWorkspaceId";

export function readLastWorkspaceId(): string | null {
  try {
    return globalThis.localStorage?.getItem(KEY) ?? null;
  } catch {
    return null;
  }
}

export function rememberWorkspaceId(id: string): void {
  try {
    globalThis.localStorage?.setItem(KEY, id);
  } catch {
    // Storage may be disabled (private mode); switching still works for this tab.
  }
}

export function pickWorkspace<T extends { id: string }>(workspaces: readonly T[]): T | null {
  const last = readLastWorkspaceId();
  return workspaces.find((w) => w.id === last) ?? workspaces[0] ?? null;
}
